import React, { useRef, useEffect, useState, useContext } from 'react';
import { DataContext } from 'contexts/DataContext';
import { GridColDef } from '@mui/x-data-grid';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Business from "@mui/icons-material/Business";
import ModalTitle from 'components/ModalTitle/ModalTitle';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';

import EditableGrid from 'components/EditableGrid/EditableGrid';
import { get, update, destroy, getColumns, bulkUpdate } from './owner_api';
import { getUsers } from '../Organization/users_api';

import 'i18n/config';
import { useTranslation } from 'react-i18next';

interface DetailProps {
    master?: any;
    row: any;
  }
  
  function Owner(props:DetailProps){
    const { t } = useTranslation();
    const dataContext = useContext(DataContext);
    const addButtonRef = useRef(null);
    const [columns, setColumns] = useState([] as GridColDef[]);
    const [decodeOwnerLoaded, setDecodeOwnerLoaded] = useState(false);
    const [owners, setOwners] = useState([]);
    const [search, setSearch] = useState('');
    const [bulkUser, setBulkUser] = useState(0 as any);

    const handleBulkUpdate = () => {
      if(!search || !bulkUser) return;
      bulkUpdate(dataContext.currentAssessment,search,bulkUser).then((response)=>{
        dataContext.toggleReloadParent();
      })
    }

    useEffect(() => {
      if(dataContext.loading) return;
      getColumns(dataContext.language).then((response) => {
        setColumns(response);
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataContext.loading, dataContext.language]);
     
    useEffect(() => {
      if(!columns.length) return;
      getUsers(dataContext.currentOrganization).then((response:any) => {
        let col = columns.filter(column => column.field === "id_user")[0] as any;
        if(col) {
          col.valueOptions = response.map((user:any) => { return {value: user.id, label: user.name} });
          setOwners(col.valueOptions);
          setDecodeOwnerLoaded(true);
          dataContext.changeShowLoader(false);
        }
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [columns]);

    return (
      <>
         <ModalTitle title={
          <>
            <Business />
            <Typography variant="pageTitle" component="h1" gutterBottom>
            {props.row.name}
            {' > '} 
            {t('Owners')}
            </Typography>
          </>
         }
        />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              padding: '30px',
              backgroundColor: (theme) => theme.palette.background.default,
            }}
          >
          {decodeOwnerLoaded && <>

            <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center' 
            }}
          >
            <Box>
            <TextField
            name='search-filter'
            variant="filled"
            fullWidth
            hiddenLabel
            sx={{width:400, marginRight:1}}
            onChange={(event)=>setSearch(event.target.value)}
        />
      </Box>
      <Box>

          <Select sx={{width:200, marginRight:1}} value={bulkUser} onChange={(event, item) => {setBulkUser(event.target.value)}}>
          {owners.map((owner:any)=>{
            return <MenuItem key={owner.value} value={owner.value}>{owner.label}</MenuItem>

          })}
        </Select>
      </Box>

  <Box>
    <Button variant="contained" onClick={handleBulkUpdate}>Applica</Button>
  </Box>

  </Box>
          <EditableGrid addButtonRef={addButtonRef} hideAddButton={true} hideDeleteButton={true}  master={props.row} columns={columns} 
          key={search}
          get={get} update={update} delete={destroy}
          name='departmentGrid'
          detailsWidth='66%'
         
          filterModel={{
            items: search !='' ? [
              { id: 1, field: 'id_category', operator: 'contains', value: search },
              /*{ id: 2, field: 'id_subcategory', operator: 'contains', value: search },*/
            ] : [],
          }}
          />
          </>}
          </Box>
      </>
    )
  }

export default Owner;